import i18next from 'i18next'

export const getLevels = (type: "conventional" | "modern" | "numeric" | "version_one" | "version_two" | "version_three" | undefined): ILevel => {
  if (!type || type === "conventional") return {
    "l1": i18next.t("board.levels.conventional.l1"),
    "l2": i18next.t("board.levels.conventional.l2"),
    "l3": i18next.t("board.levels.conventional.l3"),
    "l4": i18next.t("board.levels.conventional.l4"),
    "l5": i18next.t("board.levels.conventional.l5"),
  }

  if (type === "modern") {
    return {
      "l1": i18next.t("board.levels.modern.l1"),
      "l2": i18next.t("board.levels.modern.l2"),
      "l3": i18next.t("board.levels.modern.l3"),
      "l4": i18next.t("board.levels.modern.l4"),
      "l5": i18next.t("board.levels.modern.l5"),
    }
  } else if (type === "numeric") {
    return {
      "l1": 1,
      "l2": 2,
      "l3": 3,
      "l4": 4,
      "l5": 5
    }
  } else if (type === "version_one") {
    return {
      "l1": 1,
      "l2": 2,
      "l3": 3,
      "l4": 4,
      "l5": 5,
      "l6": 6,
      "l7": 7
    }
  } else if (type === "version_two") {
    return {
      "l1": 1,
      "l2": 2,
      "l3": 3,
      "l4": 4,
      "l5": 5,
      "l6": 6,
      "l7": 7,
      "l8": 8,
      "l9": 9,
      "l10": 10
    }
  } else if (type === "version_three") {
    return {
      "l1": i18next.t("board.levels.version_three.l1"),
      "l2": i18next.t("board.levels.version_three.l2"),
      "l3": i18next.t("board.levels.version_three.l3"),
      "l4": i18next.t("board.levels.version_three.l4")
    }
  }
  return type as ILevel
}

export const setOrderLevels = (levels: ILevel): ILevel => {
  const levelNames = [
    'l1', 'l2', 'l3', 'l4', 'l5',
    'l6', 'l7', 'l8', 'l9', 'l10'
  ]

  const sortedKeys = Object.keys(levels).sort((a, b) => {
    const indexA = levelNames.indexOf(a)
    const indexB = levelNames.indexOf(b)
    return indexA - indexB
  })

  const orderedLevels: ILevel = {}
  sortedKeys.forEach(key => {
    orderedLevels[key] = levels[key]
  })

  return orderedLevels
}
